export default __webpack_public_path__ + "static/media/gist02.9bc7b708.jpg";